import { useEffect, useRef } from "react";

export function useRefListener<T extends (...args: never[]) => unknown>(
  fn: T,
  deps: unknown[],
) {
  const fnRef = useRef(fn);

  useEffect(() => {
    fnRef.current = fn;
  }, deps);

  return fnRef;
}
